import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { AuthStorageService } from '@core/services/auth-storage.service';
import { NavigateService } from '@core/routes/services/navigate.service';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { Config } from '@shared/configs/config';
import { Subscription } from 'rxjs';

@Component({
  selector: 'df-base-left-side-navigation-footer-user',
  templateUrl: './base-left-side-navigation-footer-user.component.html',
  styleUrls: ['./base-left-side-navigation-footer-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseLeftSideNavigationFooterUserComponent implements OnInit, OnDestroy {
  Config = Config;

  sub: Subscription = new Subscription();
  hostedOpen = false;

  @HostBinding('class.short')
  get short() {
    return this.basePanelService?.routeData?.shortLeftNavigation;
  }

  constructor(
    public userService: UserService,
    private authService: AuthStorageService,
    public n: NavigateService,
    public basePanelService: BasePanelService,
    private changes: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.listenUserChanges();
    this.listenShortNavigationChange();
  }

  listenShortNavigationChange() {
    const sub = this.basePanelService.emitter.subscribe(() => {
      this.changes.detectChanges();
    });
    this.sub.add(sub);
  }

  listenUserChanges() {
    const sub = this.userService.currentUser$?.subscribe(() => {
      this.changes.detectChanges();
    });
    this.sub.add(sub);
  }

  logout() {
    this.authService.logout();
    this.n.go('sign-in');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
